<template lang="html">
  <div class=""></div>
</template>

<script>
  export default {
    name: "Logout",
    created() {
      //FB sign out
      if (!this.$_.isEmpty(this.$sdkInstances.fbSDKInstance)) {
        this.$sdkInstances.fbSDKInstance.getLoginStatus((res) => {
          if (res.status === "connected") {
            this.$sdkInstances.fbSDKInstance.logout();
          }
        });
      }

      //Google sign out
      if (!this.$_.isEmpty(this.$sdkInstances.googleSDKInstance)) {
        if (this.$sdkInstances.googleSDKInstance.isSignedIn.get()) {
          this.$sdkInstances.googleSDKInstance.signOut();
        }
      }

      //Remove token from local storage and redirect to home page
      delete localStorage.token;
      delete localStorage.role;
      this.$sessionUser._clearUserInfo();
      this.$store.commit("resetAllState");
      this.$store.commit("logout");
      this.$router.push("/");
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue